<template>
  <div class="toast-content" :class="{ 'width-auto': toastType === 1}">
    <span class="toast-title">
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    toastType: {
      type: Number,
    },
  },
  computed: {},
  methods: {
    close() {
      this.$emit('closeToast');
    },
  },
};
</script>

<style lang="less" scoped>
.toast-content {
  position: fixed;
  z-index: 9998;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 448px;
  padding: 24px;
  background: var(--toast-bg);
  border-radius: 20px;
  width: 448px;
  box-shadow: 0px 64px 64px -48px rgba(31,47,70,0.12); 
  text-align: center;
  &.width-auto {
    width: auto;
    padding: 10px 24px;
  }
  .toast-title {
    font-size: 14px;
    font-weight: 500;
    color: #fff;
  }
}

@media screen and (max-width: 767px) {
  .toast-content {
    position: fixed;
    z-index: 9998;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    padding: 30px 20px;
    // &.width-auto {
    //   padding: 10px 24px;
    // }
  }
}
</style>
